




















import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class NotFound extends Vue {
  get authData() {
    return this.$store.getters.authData;
  }

  get btnName(): string {
    const name = this.$route.query?.btnName;
    return name && typeof name === "string" ? name : "На главную";
  }

  redirect(): void {
    const path: string =
      typeof this.$route.query?.redirect === "string"
        ? this.$route.query?.redirect
        : "/";
    path && this.$router.replace({ path: path || "/" });
  }
}
